import { RefObject, useCallback, useEffect } from 'react';

export const scrollToBottom = (element: HTMLElement | null) => {
    if (!element) return;
    element.scrollTop = element.scrollHeight;
};

/**
 * Keeps the element scrolled to the bottom whenever `deps` change while enabled.
 * Returns a callback to scroll on demand (e.g. after the panel finishes expanding).
 */
export const useAutoScroll = (
    ref: RefObject<HTMLElement>,
    enabled: boolean,
    deps: unknown[]
) => {
    useEffect(() => {
        if (!enabled || !ref.current) return undefined;
        const animationFrame = window.requestAnimationFrame(() =>
            scrollToBottom(ref.current)
        );
        return () => window.cancelAnimationFrame(animationFrame);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enabled, ...deps]);

    return useCallback(() => scrollToBottom(ref.current), [ref]);
};
